import React from "react";

interface BackgroundCircleProps {
  color?: string;
  width?: number | string;
  height?: number | string;
}

const BackgroundCircle: React.FC<BackgroundCircleProps> = ({
  color = "#F5DBA8",
  width = 1440,
  height = 392,
}) => (
  <svg
    className="background-image"
    width={width}
    height={height}
    viewBox="0 0 1440 392"
    fill="none"
  >
    <circle cx="720" cy="-1007" r="1335" fill={color} />
    <path
      d="M2115.5 -1007.5C2115.5 -245.549 1490.92 372.5 720 372.5C-50.9164 372.5 -675.5 -245.549 -675.5 -1007.5C-675.5 -1769.45 -50.9164 -2387.5 720 -2387.5C1490.92 -2387.5 2115.5 -1769.45 2115.5 -1007.5Z"
      stroke={color}
      strokeWidth="39"
    />
  </svg>
);

export default BackgroundCircle;
